import { HttpRequestEntity } from 'shared/domain/httpRequest/httpRequestModel';
import {
  broadcastUpdatedProtocolItem,
  broadcastUpdatedProtocolItemError,
} from 'serviceWorker/broadcasts/inspections';
import { upsertProtocolItemComment } from 'serviceWorker/db/inspections/inspections';
import { neverReached } from 'shared/utils/neverReached';
import { ProtocolItemInDto } from 'shared/dtos/in/protocolItem';
import { scopeOfQueuedRequest } from 'serviceWorker/helpers/dataScope';

export async function broadcastProtocolItemResponse(
  request: HttpRequestEntity,
  response: ProtocolItemInDto | { error: unknown }
): Promise<void> {
  if ('error' in response && response.error) {
    return broadcastUpdatedProtocolItemError(
      response.error,
      request.data.uniqueId
    );
  }

  switch (request.method) {
    case 'PUT':
      await scopeOfQueuedRequest(request).write(() =>
        upsertProtocolItemComment({
          inspectionId: request.data.inspectionId,
          protocolItem: response as ProtocolItemInDto,
        })
      );
      return broadcastUpdatedProtocolItem(
        response as ProtocolItemInDto,
        request.data.uniqueId
      );
    case 'POST':
    case 'DELETE':
    case 'GET':
      return broadcastUpdatedProtocolItemError(
        new Error(`${request.method} method not supported for protocolItem`),
        request.data.uniqueId
      );
    default:
      neverReached(request.method);
  }
}
